import { render, staticRenderFns } from "./dateTime.vue?vue&type=template&id=80489b54&scoped=true&"
import script from "./dateTime.vue?vue&type=script&lang=js&"
export * from "./dateTime.vue?vue&type=script&lang=js&"
import style0 from "./dateTime.vue?vue&type=style&index=0&id=80489b54&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80489b54",
  null
  
)

export default component.exports